import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div>
        <div class='footer'>
          <span id='footer-text'>&copy; Copyright 2020 CoderGuides</span>
        </div>
      </div>
    );
  }
}

export default Footer;
